import * as React from 'react';

import type { W_WorkOrderReport_FindProductionData_VM } from 'ab-api/web/workOrderReport/findProductionData';

import * as FormattingUtils from '@acceligentllc/shared/utils/formatting';

import { SegmentLabel } from '@acceligentllc/storybook';

import LockedValue from 'af-components/LockedValue';

import styles from './styles.module.scss';

interface OwnProps {
	productionData: W_WorkOrderReport_FindProductionData_VM;
}

type Props = OwnProps;

const ProductionData: React.FC<Props> = (props) => {
	const { productionData } = props;

	return (
		<div className={styles.container}>
			<SegmentLabel label="Production data" />
			<div className={`${styles.row} m-t-m`}>
				<div>
					<LockedValue
						label="Revenue"
						value={FormattingUtils.moneyNormalizer(productionData.totalRevenue)}
					/>
				</div>
				<div>
					<LockedValue
						label="Service Revenue"
						value={FormattingUtils.moneyNormalizer(productionData.serviceRevenue)}
					/>
				</div>
				<div>
					<LockedValue
						label="Man Hour Average"
						value={FormattingUtils.moneyNormalizer(productionData.manHourAverage)}
					/>
				</div>
				{
					process.env.FTD_DISABLE_PR_DIFF !== 'true' &&
					productionData?.payrollDifferential !== null &&
					<div>
						<LockedValue
							label="P/R Diff"
							value={productionData?.payrollDifferential ? `$ ${(+(productionData.payrollDifferential)).toFixed(2)}` : '-'}
						/>
					</div>
				}
			</div>
			<div className={styles.row}>
				<div>
					<LockedValue
						label="Job Hours"
						value={productionData?.jobHours ?? '-'}
					/>
				</div>
				<div>
					<LockedValue
						label="Shop Hours"
						value={productionData?.shopHours ?? '-'}
					/>
				</div>
				<div>
					<LockedValue
						label="Travel Hours"
						value={productionData?.travelHours ?? '-'}
					/>
				</div>
			</div>
		</div >
	);
};

export default React.memo(ProductionData);
